import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";
import SuspensePageLoading from "../../../components/SuspensePageLoading";
import MasterData from "../../../components/MasterData";
import { links } from "./links";

const Dashboard = lazy(() => import("../../../pages/Dashboard"));
// const Jobs = lazy(() => import("../../pages/Jobs"))
const JobManagement = lazy(() => import("../../../pages/JobManagement"));
const QualityControl = lazy(() => import("../../../pages/QualityControl"));
const AssignJob = lazy(() => import("../../../pages/AssignJob"));
const UpdateJob = lazy(() => import("../../../pages/UpdateJob"));
const JobPdf = lazy(() => import("../../../pages/JobPdf"));
const DownloadJobPdf = lazy(() => import("../../../pages/DownloadJobPdf"));
const Users = lazy(() => import("../../../pages/Users"));
const AddQualityControl = lazy(() => import("../../../pages/AddQualityControl"));
const QualityDefect = lazy(() => import("../../../pages/QualityDefect"));
const AddQualityDefect = lazy(() => import("../../../pages/AddQualityDefect"));
const Profile = lazy(() => import("../../../pages/Profile"));
const GeneratePdf = lazy(() => import("../../../pages/GeneratePdfAndSave"));

const SuperVisorRoutes = () => {
    
  return (
    <>
      <Sidebar links={links} />
      <MasterData>
        <Suspense fallback={<SuspensePageLoading />}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/quality-control-cycle" element={<QualityControl />} />
            <Route
              path="/quality-control-cycle/new"
              element={<AddQualityControl />}
            />
            <Route
              path="/quality-control-cycle/:id/update"
              element={<AddQualityControl />}
            />
            <Route path="/job-management" element={<JobManagement />} />
            <Route path="/job-management/new" element={<AssignJob />} />
            <Route path="/job-management/:id/pdf" element={<JobPdf />} />
            <Route
              path="/job-management/:id/pdf/download"
              element={<DownloadJobPdf />}
            />
            <Route path="/job-management/:id/update" element={<UpdateJob />} />
            <Route
              path="/job-management/:id/generate-pdf" //for flows where user forgot password
              element={<GeneratePdf />}
            />
            <Route path="/quality-defects" element={<QualityDefect />} />
            <Route path="/quality-defects/new" element={<AddQualityDefect />} />
            <Route
              path="/quality-defects/:id/update"
              element={<AddQualityDefect />}
            />
            <Route path="/profile" element={<Profile />} />
            {/* <Route path="/jobs" element={<Jobs />} /> */}
            <Route path="/users" element={<Users />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Suspense>
      </MasterData>
    </>
  );
};

export default SuperVisorRoutes;
